import { TnplContractStatus } from "@redotech/redo-model/tnpl-contract";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getBatchTnplContractStatus = {
  name: "getBatchTnplContractStatus" as const,
  input: z.object({ orderIds: z.array(zExt.objectId()) }),
  output: z.record(
    z.string(),
    z.object({
      contractStatus: createEnum(TnplContractStatus).nullable(),
      hasTnplContract: z.boolean(),
      eligibleTnplLineItems: z.array(z.string()),
    }),
  ),
};
